import React from "react";

const MeasuringTapeIcon = () => (
  <svg
    version="1.1"
    id="product-info-icon"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    height="30px"
    width="30px"
    x="0px"
    y="0px"
    viewBox="0 0 36 36"
    xmlSpace="preserve"
  >
    <g>
      <path
        d="M14.9,15.2c0.7,0.1,1.4,0.1,2.1,0.1c0.3,0,0.5,0,0.8,0c0.8,0,1.6-0.1,2.4-0.2V12c-0.2-0.4-0.9-0.9-2.1-1.2c0,0,0,0,0,0
		c-0.1,0-0.2-0.1-0.3-0.1c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.4-0.1-0.9-0.1-1.4-0.1
		c-0.2,0-0.3,0-0.5,0c-3.4,0.2-5.3,1.4-5.3,2.2c0,0,0,0.1,0,0.1C10,13.7,12,14.8,14.9,15.2z"
      />
      <path
        d="M8.3,18.8v-6c0-0.1,0-0.1,0-0.2c0-2,2.8-3.5,6.7-3.6c0.2,0,0.4,0,0.6,0c0.7,0,1.4,0.1,2,0.2c2,0.3,3.8,1.2,4.2,2.6
		c0,0.1,0,0.2,0,0.3v2.8c2.8-0.7,4.4-1.9,4.4-2.9c0-0.1,0-0.2,0-0.3C25.5,9,19.7,7.3,14.7,7.3c-0.4,0-0.8,0-1.2,0
		C6.7,7.6,1.9,10,1.9,13.1c0,0.2,0,0.3,0.1,0.5C2.4,15.7,4.8,17.5,8.3,18.8z"
      />
      <path
        d="M9.8,19.2c2.5,0.7,5.5,1.1,8.7,1.1h7.7v-5.8c-1.7,1.3-4.6,2.2-8.2,2.3c-0.3,0-0.6,0-0.9,0c-0.9,0-1.7-0.1-2.6-0.2
		c-1.8-0.3-3.6-0.8-4.7-1.6V19.2z"
      />
      <path
        d="M2.8,17.5C2.8,17.5,2.8,17.5,2.8,17.5C2.5,17.2,2.3,17,2,16.8c0,0,0,0,0,0c-0.1-0.1-0.1-0.1-0.2-0.2v4.9
		c0,0.2,0,0.3,0.1,0.5c0.3,1.4,1.5,2.7,3.2,3.7v-3.1c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7v3.9c1,0.5,2.1,0.8,3.3,1.2v-2.2
		c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7v2.6c1.1,0.2,2.2,0.4,3.3,0.5v-3.9c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7v4
		c0.7,0,1.4,0.1,2.2,0.1h1.2v-2.6c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7v2.6h3.3v-4.1c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7
		v4.1h3.2v-2.6c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7v2.6h3.5v-6.9H18.4C11.5,21.8,5.8,20.2,2.8,17.5z"
      />
    </g>
  </svg>
);

export default MeasuringTapeIcon;



// WEBPACK FOOTER //
// ./src/components/AccordionGroup/AccordionIcons/MeasuringTapeIcon.js